"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Dataset;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));
/* eslint-disable react/no-unused-prop-types */

/** @category DataView */


function Dataset() {
  return _react["default"].createElement("div", null);
}

Dataset.propTypes = {
  /** The type of chart for the specific dataset, it can be different than the chart type */
  type: _propTypes["default"].oneOf(['line']),

  /** The values to represent in the chart */
  values: _propTypes["default"].arrayOf(_propTypes["default"].number),

  /** The title for the dataset which appears in the legend and tooltips. */
  title: _propTypes["default"].string,

  /** The fill color under the line. */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),

  /** The color of the line, if left undefined, the backgroundColor is used */
  borderColor: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),

  /** The ID of the group to which this dataset belongs to
   * (when stacked, each group will be a separate stack) */
  stack: _propTypes["default"].string,

  /** Whether to fill the area under the line */
  fill: _propTypes["default"].bool
};
Dataset.defaultProps = {
  type: undefined,
  values: [],
  title: 'Dataset',
  backgroundColor: undefined,
  borderColor: undefined,
  stack: undefined,
  fill: false
};